import type { CreateSpeaker, LanguagesAbbr, Speaker } from "../types/working-model";
import { Delete, Get, Post, Put } from "./helpers";

export const SPEAKERS_PAGE_SIZE = 18;

export const GetSpeakers = async (
	channel: number,
	token: string,
	options: { page?: number; limit?: number; search?: string } = {}
): Promise<{ results: Speaker[]; total: number }> => {
	const params = new URLSearchParams({
		page: String(options.page ?? 1),
		limit: String(options.limit ?? SPEAKERS_PAGE_SIZE),
		include_admins: 'false'
	});

	if (options.search) {
		params.append('search', options.search);
	}

	return Get(`/v3/admin/events/speakers/${channel}?${params.toString()}`, token, {}, true)
		.then(async res => await res.json());
};

export const SearchSpeakers = async (channel: number, token: string, value: string): Promise<any> => {
	return Post(`/v3/admin/events/speakers/search/${channel}`, token, { value }, false, {}, true)
		.then(async res => {
			return await res.json();
		});
};

export const InsertSpeaker = async (
	token: string,
	speaker: CreateSpeaker | Speaker,
	languages?: string[],
	baseLanguage?: LanguagesAbbr,
): Promise<any> => {
	return Post('/v3/admin/events/speakers', token, { speaker, languages, baseLanguage }, false, {}, true)
		.then(async res => {
			return await res.json();
		});
};

export const SaveSpeaker = async (token: string, speaker: Speaker, languages?: string[], baseLanguage?: LanguagesAbbr): Promise<any> => {
	return Put('/v3/admin/events/speakers', token, { speaker, languages, baseLanguage }, false, true)
		.then(res => {
			return res.ok;
		});
};

export const DeleteSpeaker = async (token: string, channel: number, speakerId: number): Promise<any> => {
	return Delete(`/v3/admin/events/speakers/${speakerId}`, token, { channel }, true);
};
